import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { SicorApiService } from '../SicorService/sicor-api.service';
import { DeviceUpdRequest } from '../SicorService/RequestObject/DeviceUpdRequest';
import { GlobalVariablesService } from '../global-variables.service';
import { StorageService } from './storage.service';
import { take, tap } from 'rxjs/operators';
import { GlobalMethodsService } from '../global-methods.service';
import { TranslateConfigService } from './translate-config.service';
import { NavigationService } from './navigation.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  constructor(private sicorAPI: SicorApiService,
    public gvs: GlobalVariablesService,
    private storage: StorageService,
    private gms: GlobalMethodsService,
    private translate: TranslateConfigService,
    private navigation: NavigationService) { }


  async sendDevice(device_id: any): Promise<boolean> {
    const user = await this.storage.getObject(this.gvs.AUTH_KEY);
    const platform = Capacitor.getPlatform().toUpperCase();
    const deviceUpdRequest: DeviceUpdRequest = new DeviceUpdRequest(user.userName, device_id, platform, 'SIC');
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.sendDeviceRequest(deviceUpdRequest)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null) {
              if (res.resultSet[0] != null && res.resultSet[0].error != null) {
                if (res.resultSet[0].error === 401) {
                  resolve(false);
                }
                else if (res.resultSet[0].error === 0) {
                  resolve(true);
                }
                else {
                  resolve(null);
                }
              }
              else {
                resolve(null);
              }
            }
          },
          error: async e => {
            resolve(null);
          }
        })
      ));
    });
  }
}
